import {
  ActionCardData,
  ActionCardModel,
  enrichActionCardWithProps,
  getAvailableTags,
  getFlowStatus,
} from '@playbooks/action-cards-utils/src'

import { Set } from '..'
import getQuestionsWithCode from '../../utils/getQuestionsWithCode'

export type SetActionCards = (data: ActionCardData) => void

export default function actionSetActionCards(set: Set): SetActionCards {
  return (data: ActionCardData) => {
    const { data: clonedData, flowData, availableTags, questionsWithCode } = processActionCardsData(data)

    set(state => ({
      ...state,
      data: clonedData,
      flowData,
      availableTags,
      questionsWithCode,
    }))
  }
}

export function processActionCardsData(data: ActionCardData) {
  const clonedData = JSON.parse(JSON.stringify(data)) as ActionCardData

  enrichActionCardWithProps(clonedData)

  const actionCardsModel = new ActionCardModel(clonedData || null!)

  const flowData = getFlowStatus(clonedData)
  const availableTags = getAvailableTags(clonedData.sections)
  const questionsWithCode = getQuestionsWithCode(actionCardsModel)

  return {
    data: clonedData,
    flowData,
    availableTags,
    questionsWithCode,
  }
}
